import request from '../request';

// 获取课程列表
export const getCourseList = (query) => {
  return request({
    url: '/api/course_manage/course/selectList',
    method: 'post',
    data: query,
  });
};

// 获取总课程列表
export const getAllCourseList = (query) => {
  return request({
    url: '/api/course_manage/course/selectAllList',
    method: 'post',
    data: query,
  });
};

// 获取课程详情
export const getCourseInfo = (query) => {
  return request({
    url: '/api/course_manage/course/getInfo',
    method: 'post',
    data: query,
  });
};

// 课程保存/修改
export const saveCourse = (query) => {
  return request({
    url: '/api/course_manage/course/save',
    method: 'post',
    data: query,
  });
};

// 获取课程全部章节+课文信息
export const selectChapterInfo = (query) => {
  return request({
    url: '/api/course_manage/course/selectChapterInfo',
    method: 'post',
    data: query,
  });
};

// 添加单元和课文
export const addChapterText = (query) => {
  return request({
    url: '/api/course_manage/course/addChapterText',
    method: 'post',
    data: query,
  });
};

// 获取课程全部阶段和内容
export const selectStageInfo = (query) => {
  return request({
    url: '/api/course_manage/course/selectStageInfo',
    method: 'post',
    data: query,
  });
};

// 添加阶段和内容
export const addStageContent = (query) => {
  return request({
    url: '/api/course_manage/course/addStageContent',
    method: 'post',
    data: query,
  });
};

// 分页查询单元
export const selectChapter = (query) => {
  return request({
    url: '/api/course_manage/course/selectChapter',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 分页查询课文
export const selectChapterTexts = (query) => {
  return request({
    url: '/api/course_manage/course/selectChapterTexts',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//音视频课审核
export const courseExamine = (query) => {
  return request({
    url: '/api/course_manage/course/examine',
    method: 'post',
    data: query,
  });
};

// 课程上线/下线
export const coursePublish = (query) => {
  return request({
    url: '/api/course_manage/course/publish',
    method: 'post',
    data: query,
  });
};

// 课程删除/恢复
export const courseDelete = (query) => {
  return request({
    url: '/api/course_manage/course/delete',
    method: 'post',
    data: query,
  });
};

// 获取课文列表
export const getTextList = (query) => {
  return request({
    url: '/api/course_manage/courseText/selectList',
    method: 'post',
    data: query,
  });
};

// 获取课程课文详情
export const getTextInfo = (query) => {
  return request({
    url: '/api/course_manage/courseText/getInfo',
    method: 'post',
    data: query,
  });
};

// 课文保存/修改
export const saveText = (query) => {
  return request({
    url: '/api/course_manage/courseText/save',
    method: 'post',
    data: query,
  });
};
// 课文上线/下线
export const textPublish = (query) => {
  return request({
    url: '/api/course_manage/courseText/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 课文删除/恢复
export const textDelete = (query) => {
  return request({
    url: '/api/course_manage/courseText/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 运营者回复_管理端
export const addTextRemark = (query) => {
  return request({
    url: '/api/course_manage/manage/addCourseRemark',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取课文留言_管理端
export const getTextMsg = (query) => {
  return request({
    url: '/api/course_manage/manage/list',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 置顶留言-取消置顶_管理端
export const textMsgPop = (query) => {
  return request({
    url: '/api/course_manage/manage/popRemark',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取留言表中课文所属课程列表_管理端
export const getMsgCoursesList = (query) => {
  return request({
    url: '/api/course_manage/manage/remark/getCourses',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 发表/屏蔽/删除留言_管理端
export const textMsgUpdata = (query) => {
  return request({
    url: '/api/course_manage/manage/updateRemarkStatus',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//获取课程资源详情
export const getCourceInfo = (query) => {
  return request({
    url: '/api/course_manage/resource/getInfo',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源保存/修改
export const saveCource = (query) => {
  return request({
    url: '/api/course_manage/resource/save',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//获取已删除的资源列表
export const selectDelList = (query) => {
  return request({
    url: '/api/course_manage/resource/selectDelList',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取资源列表
export const getSelectCourseList = (query) => {
  return request({
    url: '/api/course_manage/resource/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//通过分类获取资源列表
export const selectListByCategory = (query) => {
  return request({
    url: '/api/course_manage/resource/selectListByCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源视频切片状态
export const updateSliceStatus = (query) => {
  return request({
    url: '/api/course_manage/resource/updateSliceStatus',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//资源删除(支持批量)
export const deleteCourseList = (query) => {
  return request({
    url: '/api/course_manage/resource/delete',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//资源审核
export const examineCourse = (query) => {
  return request({
    url: '/api/course_manage/resource/examine',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//资源上线/下线
export const publishCourse = (query) => {
  return request({
    url: '/api/course_manage/resource/publish',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//获取所有分类(树型结构)
export const getCourseCategory = (query) => {
  return request({
    url: '/api/course_manage/category/allCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//删除分类
export const deleteCourseCategory = (query) => {
  return request({
    url: '/api/course_manage/category/deleteCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//添加/修改分类
export const addCourseCategory = (query) => {
  return request({
    url: '/api/course_manage/category/addCategory',
    method: 'post',
    data: {
      data: query,
    },
  });
};

//获取浏览数前十名的浏览数据
export const getTopCourseWatchDate = (query) => {
  return request({
    url: '/api/course_manage/course/getTopCourseWatchDate',
    method: 'post',
    data: {
      data: query,
    },
  });
};

// 获取课程试卷列表
export const getCourseExamList = (query) => {
  return request({
    url: '/api/zgsource_manage/exam/selectList',
    method: 'post',
    data: query,
  });
};

// 讲师列表
export const listLecturer = (query) => {
  return request({
    url: '/api/course_manage/lecturer/selectList',
    method: 'post',
    data: {
      data: query,
    },
  });
};
